import { api } from "../helpers";

const prefix = "/contacts";

export const getContactsList = (param, token) => {
	return api(`${prefix}`, "GET", undefined, param, token);
};
